<template>
  <UiModal
    v-model="isOpen"
    position="right"
    title="S-AI"
    size="small"
    :isScroll="false"
    :allowBackgroundInteraction="true"
    :noDim="true"
    :allowFloating="true"
    @update:modelValue="handleClose"
  >
    <div class="sai-modal-content">
      <!-- SAI iframe 렌더링 -->
      <SaiIframe />
    </div>
  </UiModal>
</template>

<script setup>
import { ref, watch, onMounted, nextTick } from 'vue';
import SaiIframe from './SaiIframe.vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);

const isOpen = ref(props.modelValue);
const modalRef = ref(null);

watch(
  () => props.modelValue,
  newVal => {
    isOpen.value = newVal;
    // 모달이 열릴 때 기본 너비 설정
    if (newVal) {
      nextTick(() => {
        setInitialWidth();
      });
    }
  },
  { immediate: true },
);

watch(isOpen, newVal => {
  emit('update:modelValue', newVal);
});

const handleClose = value => {
  isOpen.value = value;
};

// 초기 너비를 350px로 설정
const setInitialWidth = () => {
  if (process.client) {
    const modalContent = document.querySelector('.ui-popup__content');
    if (modalContent && !modalContent.style.width) {
      modalContent.style.width = '350px';
    }
  }
};

onMounted(() => {
  if (isOpen.value) {
    nextTick(() => {
      setInitialWidth();
    });
  }
});
</script>

<style lang="scss" scoped>
:deep(.ui-popup__content) {
  min-width: 300px !important; /* SAI 모달 최소 너비 (리사이즈 최소값과 일치) */
  top: 56px !important; /* 헤더 높이만큼 아래로 이동 */
  height: calc(100vh - 56px) !important; /* 헤더 높이를 뺀 높이 */
  max-width: calc(100vw - 100px) !important; /* 최대 너비 제한 */
  /* width는 UiModal의 modalStyle에서 인라인 스타일로 설정되므로 CSS에서 제거 */
}

.sai-modal-content {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}
</style>
